import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import styles from '../escalatedTable/escalatedTable.module.css'
import { AgencyHierachyData } from '../../Models/tableDetailsModel'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAgencyInfo } from '../../Context/agencyContext'
import { Tooltip } from 'antd';
import { HiddenColumnsForAgencyHierarchy } from "../../constants/ColumnToExcludeInAgencyHierarchy";

interface IHierachyTableRowProps {
    row: AgencyHierachyData,
    i: number,
    childIndex: number | null,
    shiftLeft: number;
}

const staticRowWith = [300, 150];

const defaultBorder = '1px solid #e0e0e0'

function getLeft(index: number) {
    const sum = staticRowWith.slice(0, index).reduce((acc, val) => acc + val, 0);
    return sum;
}

const HierachyTableRow = (props: IHierachyTableRowProps) => {
    const { row, i, shiftLeft, childIndex } = props
    const { setAgencyHierachyResponse, agencyHierachyResponse } = useAgencyInfo()

    const ToggleRow = (userId: number, flagOpen: 'childClosed' | 'childOpened') => {
        setAgencyHierachyResponse(prev => {
            if (!prev) return prev;

            const updateFlag = (hierarchyArr: AgencyHierachyData[]): AgencyHierachyData[] => {
                return hierarchyArr.map(hierarchyRow => {
                    if (hierarchyRow.userId.toString() === userId.toString()) {
                        return {
                            ...hierarchyRow,
                            openChild: flagOpen,
                        };
                    }

                    if (hierarchyRow.children) {
                        const updatedChildren = updateFlag(hierarchyRow.children);
                        if (updatedChildren !== hierarchyRow.children) {
                            return {
                                ...hierarchyRow,
                                children: updatedChildren,
                            };
                        }
                    }

                    return hierarchyRow;
                });
            };

            return {
                ...prev,
                agentHierarchyData: updateFlag(prev.agentHierarchyData),
            };
        });
    };

    const GetCellValue = (cellValue: number | string | null | undefined, keyName: string) => {
        if (cellValue === null || cellValue === undefined) {
            if (keyName === "agencyName") {
                return "No Agency"
            }
            return ""
        }
        if (keyName.includes("Percentage")) {
            return cellValue.toString() + "%"
        }
        if (keyName === "agencyName" && cellValue === "") {
            return "No Agency"
        }
        const text = cellValue.toString()
        return (
            <Tooltip title={text.length > 25 ? text : ""}>
                {text.length > 25 ? text.slice(0, 25) + "..." : text}
            </Tooltip>
        )
    }

    const IsChildOpened = (row: AgencyHierachyData) => {
        return row.openChild === 'childOpened'
    }

    const GetBorder = (row: AgencyHierachyData, childIndex: number | null) => {
        return (!IsChildOpened(row) && childIndex === null) ? defaultBorder : 'none'
    }

    const GetBorderTop = (row: AgencyHierachyData, childIndex: number | null, parentIndex: number) => {
        if (parentIndex === 0)
            return 'none'
        if (agencyHierachyResponse)
            return (!IsChildOpened(row) && childIndex === null && IsChildOpened(agencyHierachyResponse?.agentHierarchyData[parentIndex - 1])) ? defaultBorder : 'none'
    }

    return (
        <>
            <TableRow className={`${styles.escalatedTableRow}`}>
                {Object.keys(row)
                    .filter((item) =>
                        !HiddenColumnsForAgencyHierarchy.includes(item)
                        && item !== "children"
                        && item !== "openChild"
                    )
                    .map((keyName, j) => {
                    const cellValue = row[keyName as keyof AgencyHierachyData]?.toString() ?? ""

                    return (
                        <TableCell
                            key={`${row.userId}-${keyName}`}
                            align="left"
                            sx={j < 2 ?
                                {
                                    left: getLeft(j),
                                    zIndex: 1,
                                    position: 'sticky',
                                    backgroundColor: IsChildOpened(row) ? "#F0F5FB !important" : "#fff !important",
                                    fontWeight: IsChildOpened(row) && j === 0 ? "700" : "500",
                                    minWidth: staticRowWith[j],
                                    maxWidth: staticRowWith[j],
                                    borderRight: j === 1 ? defaultBorder : 'none',
                                    borderBottom: GetBorder(row, childIndex),
                                    borderTop: GetBorderTop(row, childIndex, i)
                                } : {
                                    minWidth: "300px",
                                    backgroundColor: IsChildOpened(row) ? "#F0F5FB !important" : "#fff !important",
                                    borderBottom: GetBorder(row, childIndex),
                                    borderTop: GetBorderTop(row, childIndex, i)
                                }
                            }
                        >
                            <span style={{
                                paddingLeft: `${j === 0 ? shiftLeft : 0}px`,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                {row.children?.length > 0 && (j === 0 && (row.openChild === 'childOpened' ?
                                    <KeyboardArrowUpIcon
                                        fontSize='small'
                                        sx={{ cursor: "pointer", marginRight: "10px" }}
                                        onClick={() => { ToggleRow(row.userId, 'childClosed') }}
                                    />
                                    :
                                    <KeyboardArrowDownIcon
                                        fontSize='small'
                                        sx={{ cursor: "pointer", marginRight: "10px" }}
                                        onClick={() => { ToggleRow(row.userId, 'childOpened') }}
                                    />)
                                )}
                                <span>
                                    {GetCellValue(cellValue, keyName)}
                                </span>
                            </span>
                        </TableCell>
                    )
                })}
            </TableRow>
            {(row.children !== null && row.openChild === 'childOpened') &&
                row.children.map((childRow, childIndex) => (
                    <HierachyTableRow
                        key={childRow.userId}
                        row={childRow}
                        i={i}
                        childIndex={childIndex}
                        shiftLeft={shiftLeft + 30}
                    />
                ))
            }
        </>
    )
}

export default HierachyTableRow